import Popup from 'reactjs-popup'
import '../../styles/userpage.css'
import Bookitem from './bookitem'


const inProgress = ({ books, updateStateToExistingBook, setJournalBookTitle, setJournalTitle, setJournalContent,
    setTitle, setStatus, setCurrentPage, journalOptions, handleAddJournal, filterJournals, handleUpdateBook }) => {
    return (
        (books.filter((book) => book["status"] === "In Progress").length > 0)
            ?
            books.filter((book) => book["status"] === "In Progress").map((book) => <div
                onMouseEnter={() => { updateStateToExistingBook(book); setJournalBookTitle(book.name); setJournalTitle("Untitled") }}
                className="py-3 inprogress-item">
                <Bookitem
                    filterJournals={filterJournals}
                    handleAddJournal={handleAddJournal}
                    setTitle={setTitle}
                    setStatus={setStatus}
                    setCurrentPage={setCurrentPage}
                    handleUpdateBook={handleUpdateBook}
                    book={book} />
                <hr className="inprogress-line"></hr>
            </div>
                // <Popup
                //         trigger={<div 
                //                 onMouseEnter={() => {updateStateToExistingBook(book); setJournalBookTitle(book.name); setJournalTitle("Untitled")}}
                //             className="inprogress-item">
                //             <Bookitem book={book} />
                //             {/* <div className="inline w-auto mr-7"> <span className="book-title">{book.name}</span> </div>
                //             <div className="inline w-auto mr-7"> <span className="font-light">@  Pg. {book.currentPage}</span> </div> */}
                //             <hr className="mt-3 inprogress-line"></hr>
                //             {/* <div className="inline w-auto">
                //                 <div className="inline w-auto mr-7">Start: {book.createdAt.substring(0, 10)}</div>
                //                 <div className="inline w-auto">Latest: {book.updatedAt.substring(0, 10)}</div>
                //             </div> */}
                //         </div>}
                //         modal>
                /* {close => (
                    <div className="sm:px-5 h-screen overflow-auto mt-7">
                        <button className="float-left outline-none focus:outline-none font-bold text-3xl" onClick={close}>
                            &times;
                        </button>
                        <div className="grid grid-cols-1 md:grid-cols-2 items-start justify-content-center w-screen">
                            <div id="in-progress-books-edit-info-wrapper" className="px-3">
                                <div id="in-progress-books-edit-info" className="max-h-80 h-auto my-2 w-30 md:w-1/2 md:mx-auto mr-0
                                border-2 bg-white rounded-lg p-5 item-start">
                                    <div>
                                        <div className="font-semibold"> Edit Book Info</div>
                                        <div className="content">
                                            <label className="font-light text-sm">Title</label><br/>
                                            <input 
                                                onChange={e => setTitle(e.target.value)}
                                                required className="w-max italic font-light text-sm 
                                                mb-2 px-3 py-1 border-2 bg-gray-200 rounded-md focus:outline-none 
                                                focus:border-blue-200 transition-colors" type="text" defaultValue={book.name}></input> <br/>
                                            <label className="font-light text-sm">Status</label><br/>
                                            <select 
                                                onChange={e => setStatus(e.target.value)}
                                                required className="w-max font-light text-sm mb-2 px-3 py-1 border-2 bg-gray-200 rounded-md focus:outline-none focus:border-blue-200 transition-colors" type="text">
                                                <option selected>In Progress</option>   
                                                <option>Completed</option> 
                                            </select> <br/>
                                            <label className="font-light text-sm">Current Page</label><br/>
                                            <input 
                                                onChange={e => setCurrentPage(e.target.value)}
                                                required className="w-2/5 font-light text-sm pl-2 py-1 
                                                border-2 bg-gray-200 rounded-md focus:outline-none 
                                                focus:border-blue-200 transition-colors" 
                                                type="number" 
                                                defaultValue={book.currentPage.toString()}></input> <br/>
                                            <button className="text-white border-2 p-1 px-1 mt-4 bg-blue-300 hover:bg-blue-400 transition-colors" onClick={() => {close(); handleUpdateBook(book);}}>Save</button>
                                        <br />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div id="in-progress-books-journals-wrapper" className="w-full flex flex-col px-3">
                                <div id="in-progress-books-journal" className="w-full sm:w-7/12 md:w-9/12 border-0 
                                my-2 h-auto bg-pink-300 rounded-md p-3 flex flex-col">
                                    <div className="font-bold ml-3 mb-2 underline">Record Your Thoughts</div>
                                    <div className="grid">
                                        <div className="grid grid-rows-2 flex flex-col">
                                            <input onChange={e => setJournalTitle(e.target.value)} placeholder={"Journal Title (opt)"} type="text" className="mx-3 mt-1 p-2 text-sm font-base bg-pink-200 h-6 w-5/6 border-0 rounded-md italic focus:outline-none"></input>
                                            <select onChange={e => setJournalBookTitle(e.target.value)} className="text-gray-500 mx-3 mt-1 text-sm font-base 
                                                bg-pink-200 h-6 w-5/6 border-0 rounded-md italic px-1focus:outline-none">
                                                <option value="" className="text-red-400" selected>{book.name}</option>
                                                {journalOptions(book.name)}
                                            </select>
                                        </div> 
    
                                        <div className="w-9/12 max-w-md flex flex-col">
                                            <textarea
                                                id="in-progress-books-journal-textarea"
                                                onChange={e => setJournalContent(e.target.value)} 
                                                placeholder={"Write about what you read today..."} style={{resize:"none"}} 
                                                className="p-2 text-sm font-light ml-3 m-4 mb-3 bg-pink-200 h-48 max-h-60 w-full border-0 rounded-md focus:outline-none"></textarea>
                                            <button className="ml-3 text-sm font-semibold mx-2 border-0 mb-2
                                                    border-black bg-pink-200 px-3 py-1 hover:bg-pink-400 mb-2 rounded-md
                                                    transition-colors focus:outline-none" 
                                                onClick={() => {handleAddJournal(); document.querySelector("#in-progress-books-journal-textarea").value=""}}>
                                                    Create Journal
                                            </button>
                                        </div>
                                    </div>
                                </div> 
                                
                                <div className="w-full sm:w-7/12 md:w-9/12 max-h-72 border-0 
                                my-2 h-auto bg-pink-200 rounded-md p-3 overflow-auto">
                                        {filterJournals(book.name)}
                                </div>
                            </div>
                        </div>
                    </div>
                )} */
                // </Popup >
            )
            :
            <div className="ml-3 font-extralight text-sm">No books have been logged yet</div>)

}

export default inProgress;